<template>
  <v-app>
    <div>
      <Nav v-if="this.$route.path=='/help' ||this.$route.path=='/dashboard' || this.$route.path=='/quotes'|| this.$route.path=='/graphs'|| this.$route.path=='/decisiontracker'||  this.$route.path=='/dailybriefing'|| this.$route.path=='/forms' ||this.$route.path=='/quotegenerator' ||this.$route.path=='/invoicegenerator' ||this.$route.path=='/interface' ||this.$route.path=='/widgets' ||this.$route.path=='/invoices' ||  this.$route.path=='/departments' ||  this.$route.path=='/sales' || this.$route.path=='/appointments' || this.$route.path=='/info' || this.$route.path=='/dailyagenda' || this.$route.path=='/training'  || this.$route.path=='/marketing' || this.$route.path=='/projects' ||this.$route.path=='/accounting' || this.$route.path=='/hr' || this.$route.path=='/infrastructure' || this.$route.path=='/financials' || this.$route.path=='/inventory' || this.$route.path=='/brand' " />

      <router-view></router-view>
      <br />
      <br />
      <Footer v-if="this.$route.path!=='/'" />
    </div>
  </v-app>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";

export default {
  name: "App",
  data: () => ({
    SpeechRecognition: {},
    recognition: {}
  }),
  components: {
    Footer,
    Nav
  },
  methods: {},
  mounted() {
    // alert(this.$route.path);
  }
};
</script>
  <style>
body {
  font-family: "Segoe UI", Arial, sans-serif;
}
</style>
